import SpineWrapper from '@Core/Animation/SpineWrapper';
import { GameComponent } from '@Core/GameComponent/GameComponent';
import { GameScene } from '@Core/GameScene/GameScene';
import AssetsLoadManager from '@Core/Loader/AssetsLoadManager';
import { ELayeringOrder } from '@GFTypes/LayeringOrder';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { Container } from 'pixi.js';

export class InfoDisplay extends GameComponent {
    static readonly SPINE_KEY: string = 'infoDisplay';
    static readonly SKIN_NAME: string = 'default';

    public infoDisplaySpine: SpineWrapper;
    private currentPage: number;
    private pageAmount: number;
    private shouldPlayNextPage: boolean;
    private spineKey: string;
    public scene: GameScene;

    constructor(scene: GameScene) {
        super(scene);
        this.scene = scene;
        Logger.log(LoggerLevel.Constructor, { class: InfoDisplay.name, source: LoggerSource.Game, message: 'InfoDisplay constructor' });
        this.currentPage = 0;
        this.shouldPlayNextPage = true;
    }

    onInit(): void {
        this.spineKey = AssetsLoadManager.getSpinesConfiguration().assets.filter((asset) => asset.key === InfoDisplay.SPINE_KEY)[0].key;
    }

    onCreate() {
        const container = new Container({ parent: this.scene.stage });

        this.infoDisplaySpine = new SpineWrapper(
            this.scene,
            {
                x: this.scene.screen.width / 2,
                y: this.scene.screen.height / 2
            },
            { dataKey: this.spineKey },
            true
        );

        this.infoDisplaySpine.spine.zIndex = ELayeringOrder.INFO_DISPLAY;
        container.zIndex = ELayeringOrder.INFO_DISPLAY;
        container.addChild(this.infoDisplaySpine.spine);

        this.pageAmount = this.infoDisplaySpine.eventManager.countWildcardAnimations(EGameEvents.INFO_DISPLAY_$);
        if (this.pageAmount === 1) this.shouldPlayNextPage = false;

        this.nextPage();
    }

    private async nextPage() {
        this.currentPage = (this.currentPage % this.pageAmount) + 1;
        EventsCenter.emit(EGameEvents.INFO_DISPLAY_$, { eventIds: [this.currentPage] });

        if (this.shouldPlayNextPage) {
            await this.infoDisplaySpine.waitForAnimationEvent(EGameEvents.INFO_DISPLAY_$, 'complete', [this.currentPage]).promise;
            this.nextPage();
        }
    }
}
